<template>
  <div class="switch-confirm-dialog" v-if="visible">
    <div class="dialog-popup">
      <div class="dialog-content">
        <img
          src="@/assets/aiTeacher/grade-close.png"
          alt=""
          class="dialog-close-btn"
          @click="handleCancel"
        />
        
        <!-- 警告图标和标题 -->
        <div class="dialog-header">
          <img
            src="@/assets/aiTeacher/warning.png"
            alt=""
            class="warning-icon"
          />
          <div class="title">请注意</div>
        </div>

        <!-- 提示内容 -->
        <div class="dialog-message">
          当前操作后,您正在进行的对话将会结束,开启新一轮对话。请确认是否继续切换?
        </div>

        <!-- 按钮区域 -->
        <div class="dialog-buttons">
          <div class="btn btn-cancel" @click="handleCancel">
            继续当前对话
          </div>
          <div class="btn btn-confirm" @click="handleConfirm">
            开始新对话
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";

// eslint-disable-next-line no-unused-vars
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["close", "confirm", "cancel"]);

// 确认开始新对话
const handleConfirm = () => {
  emit("confirm");
  handleClose();
};

// 取消/继续当前对话
const handleCancel = () => {
  emit("cancel");
  handleClose();
};

// 关闭弹窗
const handleClose = () => {
  emit("close");
};
</script>

<style lang="scss">
.switch-confirm-dialog {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  left: 0;
  top: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;

  .dialog-popup {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    padding: 5px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color: #7e7c84;
    border-radius: 50px;

    .dialog-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      width: 440px;
      min-height: 215px;
      background-color: #fff;
      border-radius: 50px;
      padding: 30px 36px 25px;
      box-sizing: border-box;

      .dialog-close-btn {
        position: absolute;
        top: -16px;
        right: -16px;
        transform: translate(50%, 0%);
        width: 32px;
        height: 32px;
        cursor: pointer;
        z-index: 10;
      }

      .dialog-header {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;

        .warning-icon {
          width: 18px;
          height: 18px;
          margin-right: 5px;
        }

        .title {
          font-weight: bold;
          font-size: 18px;
          color: #FF6767;
        }
      }

      .dialog-message {
        font-size: 17px;
        color: #333333;
        line-height: 22px;
        text-align: center;
        margin-bottom: 30px;
        padding: 0 10px;
      }

      .dialog-buttons {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        // gap: 15px;

        .btn {
          width: 155px;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 40px;
          border-radius: 20px;
          font-size: 15px;
          cursor: pointer;
          transition: all 0.3s ease;

          &.btn-cancel {
            background: #ffffff;
            border: 1px solid #ffa061;
            color: #ffa061;
            margin-right: 30px;
          }

          &.btn-confirm {
            background: linear-gradient(90deg, #ffae79 0%, #ffa061 100%);
            box-shadow: inset 0px 1px 3px 1px rgba(255, 255, 255, 0.3);
            color: #ffffff;
          }

          &:active {
            opacity: 0.8;
          }
        }
      }
    }
  }
}
</style>

